import classNames from "classnames";
import "./kuika-info-box.scss";

/** `white` and `gray` are neutral boxes; the rest are callouts in a tone family (green = success). */
export type KuikaInfoBoxColor = "white" | "gray" | "blue" | "yellow" | "red" | "green";

export interface KuikaInfoBoxProps {
  leftUnit?: React.ReactNode;
  rightUnit?: React.ReactNode;
  color?: KuikaInfoBoxColor;
  style?: React.CSSProperties;
  /** Layout only — the box owns its own colour, padding and radius. */
  className?: string;
}

const KuikaInfoBox = ({
  leftUnit,
  rightUnit,
  color = "white",
  style,
  className: extraClassName
}: KuikaInfoBoxProps): JSX.Element => {
  const className: string = classNames("kuika-info-box", extraClassName, `kuika-info-box--${color}`);

  return (
    <div className={className} style={style}>
      <div className="kuika-info-box__left-unit">{leftUnit}</div>
      {rightUnit && <div className="kuika-info-box__right-unit">{rightUnit}</div>}
    </div>
  );
};

export default KuikaInfoBox;
